import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  containerStyle: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    flex: 1,
  },
  leftItemsContainer: {
    flexShrink: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  leftIcon: { marginRight: 11 },
  titleStyle: theme => ({
    fontSize: 18.7,
    lineHeight: 25,
    fontFamily: Fonts.type.VFFont,
    color: theme.colors.headerColor,
  }),
  rightIcon: { marginLeft: 7 },
  descriptionStyle: theme => ({
    fontSize: 14.6,
    lineHeight: 18.7,
    fontFamily: Fonts.type.VFFont,
    color: theme.colors.textColorTwo,
    marginLeft: 45,
  }),
});
